import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import styled from "styled-components";
import FooterLP from "../landingPage/FooterLP";
import HomeComponent from "pages/landingPage/HomeComponent";
import Loader from "loaders/Loader";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { FaCheckSquare } from "react-icons/fa";
import { CgUnavailable } from "react-icons/cg";
import { useTranslation } from "react-i18next";

function Pricing() {
  const { t } = useTranslation("marketing");
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { isLoading, isError, message } = useSelector((state) => state.posts);

  const [isActive, setIsActive] = useState(false);
  const [currentDetail, setCurrentDetail] = useState();
  const [memberAmount, setMemberAmount] = useState("");

  const change = () => {
    const randomIndex =
      shareDetailsArray[Math.floor(Math.random() * shareDetailsArray.length)];
    setCurrentDetail(randomIndex);
  };

  const handleInput = (e) => {
    setMemberAmount(e.target.value);
  };

  useEffect(() => {
    if (memberAmount.length > 0) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [memberAmount]);

  useEffect(() => {
    console.log("useEffect ran");
    const interval = setInterval(change, 1050);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isError) {
      console.log(message);
    }
    if (user) {
      navigate("/home");
    }
  }, [user, navigate, isError, message]);

  if (isLoading) {
    return <Loader />;
  }

  const shareDetailsArray = t("pricing.rotatingFeatures", {
    returnObjects: true,
  });

  const handleClickGetStarted = () => {
    localStorage.setItem("registerType", "church");

    navigate("/register");
  };

  let imageToShow;
  try {
    imageToShow = require("../../images/lp-church.jpg");
  } catch (e) {
    imageToShow = null;
  }

  return (
    <>
      {/* <HomeComponent /> */}
      <PricingSection>
        <PTitle>{t("pricing.title")}</PTitle>
        <PricingDetails>
          <PricingItem>
            <section>
              <h1>{t("pricing.basic.name")}</h1>
              <span>{t("pricing.free")}</span>

              <FeaturesAvailable>
                {t("pricing.available")}
                <ul>
                  <li>
                    <FaCheckSquare />
                    {t("pricing.features.posts")}{" "}
                    <SubText>{t("pricing.features.postsDetail")}</SubText>
                  </li>
                  <li>
                    <FaCheckSquare />
                    {t("pricing.features.events")}
                  </li>

                  <li>
                    <FaCheckSquare />
                    {t("pricing.features.messaging")}
                  </li>

                  <li>
                    <FaCheckSquare />
                    {t("pricing.features.announcements")}
                  </li>

                  <li>
                    <FaCheckSquare />
                    {t("pricing.features.polls")}
                  </li>

                  <li>
                    <FaCheckSquare />
                    {t("pricing.features.feedback")}
                  </li>

                  <li>
                    <FaCheckSquare />
                    {t("pricing.features.bulletins")}
                  </li>

                  <br />
                  {t("pricing.unavailable")}
                  <li>
                    <CgUnavailable color="grey" />
                    {t("pricing.features.directory")}
                  </li>

                  <li>
                    <CgUnavailable color="grey" />
                    {t("pricing.features.giving")}{" "}
                    <SubText>{t("pricing.features.givingDetail")}</SubText>
                  </li>

                  <li>
                    <CgUnavailable color="grey" />
                    {t("pricing.features.files")}{" "}
                    <SubText>{t("pricing.features.filesDetail")}</SubText>
                  </li>

                  <li>
                    <CgUnavailable color="grey" />
                    {t("pricing.features.media")}{" "}
                    <SubText>{t("pricing.features.mediaDetail")}</SubText>
                  </li>
                </ul>
              </FeaturesAvailable>
            </section>
            <section>
              <GetStartedButton onClick={handleClickGetStarted}>
                {t("pricing.getStarted")}
              </GetStartedButton>
            </section>
          </PricingItem>

          <PricingItem annual={true}>
            <section>
              <h1>{t("pricing.premium.name")}</h1>
              <span>
                <AttachMoneyIcon /> 15.00
              </span>{" "}
              {t("pricing.perMonth")}
              <FeaturesAvailable>
                <ul>
                  <li>
                    <FaCheckSquare color="green" />
                    {t("pricing.features.posts")}
                  </li>
                  <li>
                    <FaCheckSquare color="green" />
                    {t("pricing.features.events")}
                  </li>
                  <li>
                    <FaCheckSquare color="green" />
                    {t("pricing.features.messaging")}
                  </li>
                  <li>
                    <FaCheckSquare color="green" />
                    {t("pricing.features.announcements")}
                  </li>
                  <li>
                    <FaCheckSquare color="green" />
                    {t("pricing.features.polls")}
                  </li>
                  <li>
                    <FaCheckSquare color="green" />
                    {t("pricing.features.feedback")}
                  </li>
                  <li>
                    <FaCheckSquare color="green" />
                    {t("pricing.features.bulletins")}
                  </li>
                  <li>
                    <FaCheckSquare color="green" />
                    {t("pricing.features.directory")}
                  </li>
                  <li>
                    <FaCheckSquare color="green" />
                    {t("pricing.features.giving")}
                  </li>
                  <li>
                    <FaCheckSquare color="green" />
                    {t("pricing.features.files")}
                  </li>
                  <li>
                    <FaCheckSquare color="green" />
                    {t("pricing.features.media")}
                  </li>
                </ul>
              </FeaturesAvailable>
            </section>
            <section>
              <GetStartedButton onClick={handleClickGetStarted} annual={true}>
                {t("pricing.getStarted")}
              </GetStartedButton>
            </section>
          </PricingItem>
        </PricingDetails>

        <MorePricingDetails style={{ marginTop: "150px" }}>
          <h1>{t("pricing.howItWorks")}</h1>

          <DetailsSection>
            <SectionItem>
              <h2>{t("pricing.trial.title")}</h2>
              <p>{t("pricing.trial.body")}</p>
            </SectionItem>

            <SectionItem>
              <h2>{t("pricing.members.title")}</h2>
              <p>{t("pricing.members.body")}</p>
            </SectionItem>
          </DetailsSection>
        </MorePricingDetails>
      </PricingSection>
      <FooterLP />
    </>
  );
}

export default Pricing;

const SubText = styled.div`
  font-size: 11px;
  color: #ccc;
  margin-left: 10px;
`;

const FeaturesAvailable = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ul {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  li {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }

  svg {
    margin-right: 10px;
    color: green;
  }
`;

const SectionItem = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  padding: 20px;

  h2 {
    font-size: 20px;
    margin-bottom: 10px;
  }
`;

const MorePricingDetails = styled.div`
  margin-top: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    margin-bottom: 40px;
  }
`;

const DetailsSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  border: none;
`;

const GetStartedButton = styled.div`
  width: 100px;
  height: 40px;
  background-color: ${(props) => (props.annual ? "white" : "var(--lightThemeFontColor)")};
  color: ${(props) => (props.annual ? "var(--themeColor)" : "white")};
  border: 3px solid
    ${(props) => (props.annual ? "white" : "var(--lightThemeFontColor)")};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.5s;
  font-size: 14px;

  &:hover {
    background-color: ${(props) => (props.annual ? "var(--themeColor)" : "white")};
    color: ${(props) => (props.annual ? "white" : "var(--lightThemeFontColor)")};
    border: 3px solid ${(props) => (props.annual ? "white" : "grey")};
  }
`;
const PricingItem = styled.div`
  width: 480px;
  height: 760px;
  border-radius: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${(props) => (props.annual ? "white" : "var(--lightThemeFontColor)")};
  /* color: var(--lightThemeFontColor); */
  justify-content: space-between;

  padding: 20px;
  background-color: ${(props) => (props.annual ? "var(--themeColor)" : "white")};
  box-shadow: 0 0 10px #164a0f;
  padding-top: 40px;

  h1 {
    font-size: 18px;
    font-weight: normal;
    margin-bottom: 10px;
  }

  section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  p {
    font-size: 12px;
    width: 85%;
    text-align: center;
  }
  span {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 10px;

    display: flex;
    flex-direction: row;
    align-items: center;

    & > svg {
      font-size: 30px;
    }
  }

  transition: 0.3s;

  border: 6px solid transparent;

  &:hover {
    box-shadow: 0 0 45px rgba(22, 74, 15, 0.3);
    border-color: #a0d6b4;
  }
`;

const PricingSection = styled.div`
  padding-top: 50px;
  height: fit-content;
  width: 100%;
  background-color: #f0f8ff; /* Light blue background */
  color: #2e2e2e;
  font-weight: bold;
  padding-bottom: 50px;

  /* Styling for PricingItem */
  // & > div > div {
  //   border: 6px solid #e0e0e0;
  //   box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  //   transition: 0.3s;

  //   &:hover {
  //     box-shadow: 0 0 25px rgba(22, 74, 15, 0.3);
  //     border-color: #a0d6b4;
  //   }

  //   &[annual="true"] {
  //     border-color: var(--themeColor);
  //     box-shadow: 0 0 20px rgba(22, 74, 15, 0.2);

  //     &:hover {
  //       box-shadow: 0 0 30px rgba(22, 74, 15, 0.4);
  //     }
  //   }
  // }

  /* add a gap between the two row elements */
`;
const PricingDetails = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: fit-content;
  align-self: center;
  justify-self: center;
  border-radius: 20px;
  margin-top: 30px;

  /* add a gap between the two row elements */
  & > div {
    margin-left: 30px;
  }
`;
const PTitle = styled.div`
  font-size: xx-large;
`;
